<template>
  <div
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>预约详情</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="back">返回</el-button>
      </div>
      <el-form label-position="right" label-width="80px" :model="orderData" class="form">
        <el-form-item label="课程时间" class="box">
          <el-date-picker
            v-model="orderData.startTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            style="width:100%"
            :disabled="orderData.status!='未完成'"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预约时间" class="box">
          <el-input v-model="orderData.createTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="微信名称" class="box">
          <el-input v-model="orderData.nickName" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名" class="box">
          <el-input v-model="orderData.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机号" class="box">
          <el-input v-model="orderData.mobile" disabled></el-input>
        </el-form-item>
        <el-form-item label="地址" class="box">
          <el-input v-model="orderData.addr" disabled></el-input>
        </el-form-item>
        <el-form-item label="课程类型" class="box">
          <el-input v-model="orderData.courseType" disabled></el-input>
        </el-form-item>
        <el-form-item label="预约类型" class="box">
          <el-input v-model="orderData.orderType" disabled></el-input>
        </el-form-item>
        <el-form-item label="预约人数" class="box" v-if="orderData.personNumber!=0">
          <el-input v-model="orderData.personNumber" disabled></el-input>
        </el-form-item>
        <el-form-item label="预约课时" class="box">
          <el-input v-model="orderData.longTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="课程状态" class="box">
          <el-input v-model="orderData.courseStatus" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单状态" class="box">
          <el-input v-model="orderData.status" disabled></el-input>
        </el-form-item>
        <el-form-item label="课程安排" class="box">
          <el-select
            class="wd50 mr"
            v-model="bigVal"
            placeholder="请选择"
            @focus="getBigType(orderData.courseTypeId)"
            @change="getSmallType(bigVal)"
          >
            <el-option
              v-for="item in bigType"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            ></el-option>
          </el-select>
          <el-select
            class="wd50"
            v-model="smallVal"
            placeholder="请选择"
          >
            <el-option
              v-for="item in smallType"
              :key="item.id"
              :label="item.dictValue"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教练安排" class="box">
          <el-select
            class="wd100"
            v-model="coachVal"
            placeholder="请选择"
          >
            <el-option
              v-for="item in coachs"
              :key="item.id"
              :label="item.coachName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button
          class="saveBtn"
          @click="commit"
          type="primary"
        >保存教练及课程</el-button>
        <el-button
          v-if="orderData.status=='未完成'"
          class="saveBtn"
          @click="change"
          type="primary"
        >修改预约日期</el-button>
        <el-button
          v-if="orderData.courseStatus=='已安排'&&orderData.status=='未完成'"
          class="saveBtn"
          @click="finish"
          type="primary"
        >订单已完成</el-button>
        <el-button
          class="saveBtn"
          @click="cancel"
          type="primary"
        >取消订单</el-button>
        <el-button
          v-if="orderData.courseStatus=='已安排'&&orderData.status=='已完成'||orderData.status=='已取消'"
          class="saveBtn"
          @click="back"
          type="primary"
        >返回</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";
export default {
  data() {
    return {
      orderData: {},
      bigVal: "",
      smallVal: "",
      bigType: [],
      smallType: [],
      coachVal: "",
      coachs: [],
      loading: false
    };
  },
  mounted() {
    this.getCoach();
    this.getData();
  },
  methods: {
    commit() {
      var that = this;
      let id = this.$route.query.id;
      if (that.coachVal && that.smallVal) {
        that
          .$confirm("请确认保存所选择的课程与教练？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          })
          .then(() => {
            that.$axios
              .post(this.baseUrl + "/addCoach", {
              // .post( "/gymTest/addCoach", {
                orderId: id,
                coachId: that.coachVal,
                parentCourseId: that.smallType[0].dicParentId,
                courseId: that.smallVal
              })
              .then(res => {
                console.log(res);
                if (res.data.code == 0) {
                  that.$notify({
                    title: "提交成功",
                    message: "已成功安排课程和教练，请在已安排课程中查看详情！",
                    type: "success"
                  });
                  this.back();
                } else {
                  that.$notify.error({
                    title: "提交失败",
                    message: res.message,
                  });
                }
              })
              .catch(error => {
                console.log(error);
              });
          });
      } else {
        that.$notify.error({
          title: "提交失败",
          message: "请选择课程和教练"
        });
      }
    },
    change() {
      var that = this;
      let id = this.$route.query.id;
      that
        .$confirm("请确认修改预约日期？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
        .then(() => {
          that.$axios
            .post(this.baseUrl + "/modifyOrder", {
            // .post("/gymTest/modifyOrder", {
              orderId: id,
              createTime: that.orderData.startTime,
              classHourId: that.orderData.longTimId
            })
            .then(res => {
              console.log(res);
              that.$notify({
                title: "提交成功",
                message: "已成功修改预约日期！",
                type: "success"
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    finish() {
      var that = this;
      let id = this.$route.query.id;
      that
        .$confirm("请确认订单已完成, 确认后无法撤回", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
        .then(() => {
          that.$axios
            .get(this.baseUrl + "/modifyStatus", {
            // .get("/gymTest/modifyStatus", {
              params: {
                orderId: id
              }
            })
            .then(res => {
              console.log(res);
              if (res.data.code == 0) {
                that.$notify({
                  title: "提交成功",
                  message: "已成功提交订单状态，请在已完成订单中查看详情！",
                  type: "success"
                });
                this.back();
              } else {
                that.$notify.error({
                  title: "提交失败",
                  message: res.message,
                });
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消提交"
          });
        });
    },
    cancel() {
      var that = this;
      let id = this.$route.query.id;
      that
        .$confirm("取消订单, 确认后无法撤回", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
        .then(() => {
          that.$axios
            .get(this.baseUrl + "/cancelOrder", {
            // .get("/gymTest/cancelOrder", {
              params: {
                orderId: id
              }
            })
            .then(res => {
              console.log(res);
              if (res.data.code == 0) {
                that.$notify({
                  title: "取消成功",
                  message: "已取消该订单，请在已取消订单中查看详情！",
                  type: "success"
                });
                this.back();
              } else {
                that.$notify.error({
                  title: "提交失败",
                  message: res.message,
                });
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消操作"
          });
        });
    },
    back() {
      this.$router.go(-1);
    },
    getData() {
      var that = this;
      that.loading = true;
      let id = this.$route.query.id;
      let status = this.$route.query.courseStatus;
      console.log(id);
      this.$axios
        .post(this.baseUrl + "/queryOrder", {
        // .post("/gymTest/queryOrder", {
          courseStatus: status,
          orderId: id
        })
        .then(res => {
          that.loading = false;
          console.log(res);
          let orderType = res.data.data[0].orderType;
          if (orderType == "1") {
            orderType = "个人预约";
          } else {
            orderType = "团体预约";
          }
          res.data.data[0].orderType = orderType;

          let courseStatus = res.data.data[0].courseStatus;
          if (courseStatus == "0") {
            courseStatus = "未安排";
          } else if (courseStatus == "1") {
            courseStatus = "已安排";
          } else {
            courseStatus = "已取消";
          }
          res.data.data[0].courseStatus = courseStatus;

          let status = res.data.data[0].status;
          if (status == "0") {
            status = "未完成";
          } else if (status == "1") {
            status = "已完成";
          } else {
            status = "已取消";
          }

          // 回填课程和教练数据
          that.coachVal = res.data.data[0].coachId;
          that.getBigType(res.data.data[0].courseTypeId);

          res.data.data[0].status = status;
          this.orderData = res.data.data[0];
        })
        .catch(error => {
          console.log(error);
        });
    },
    getBigType(val) {
      console.log(val);
      var that = this;
      that.smallType = [];
      that.smallVal = "";
      that.orderData.parentCourseId = "";
      that.$axios
        .get(that.baseUrl + "/common/queryDic", {
        // .get("/gymTest/common/queryDic", {
          params: {
            code: val
          }
        })
        .then(res => {
          console.log(res);
          that.bigType = res.data;
          // 数据回填
          for (var i = 0; i < that.bigType.length; i++) {
            if (that.bigType[i].id == that.orderData.parentCourseId) {
              that.bigVal = that.bigType[i].dictCode;
              that.getSmallType(that.bigVal);
              that.smallVal = that.orderData.courseId;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getSmallType(val) {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/common/queryDic", {
        // .get("/gymTest/common/queryDic", {
          params: {
            code: val
          }
        })
        .then(res => {
          console.log(res);
          that.smallType = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCoach() {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/queryCoach", {})
        // .get("/gymTest/queryCoach", {})
        .then(res => {
          console.log(res);
          that.coachs = res.data;
          // for (var i = 0; i < that.coachs.length; i++) {
          //   if (that.coachs[i].id == that.orderData.coachId) {
          //     that.coachVal = that.coachs[i].id
          //   }
          // }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  components: {
    ToolBar,
    HelpHint
  }
};
</script>
<style scoped>
.form {
  overflow: hidden;
}
.box {
  width: 48%;
  float: left;
}
.wd50 {
  width: 47%;
}
.wd100 {
  width: 100%;
}
.mr {
  margin-right: 6%;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.btn-box {
  text-align: center;
  margin: 20px auto;
}
</style>
